import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { CRLReason } from "@peculiar/asn1-x509";
export class RevokedInfo {
    constructor(params = {}) {
        this.revocationTime = new Date();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.GeneralizedTime })
], RevokedInfo.prototype, "revocationTime", void 0);
__decorate([
    AsnProp({ type: CRLReason, context: 0, optional: true })
], RevokedInfo.prototype, "revocationReason", void 0);
